import fetchApi from './api';
import {ApiResponse, LoginResponse, SearchPaging} from 'models/model';
import fetchApiBlob from './apiBlob';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const StudentCreate = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Student/Create', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const StudentUpdate = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Student/Update', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const StudentDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Student/Delete', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const StudentGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Student/Get', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const StudentGetPaging = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Student/GetPaging', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const StudentImport = async (courseId: string, file: File): Promise<ApiResponse> => {
    const formData = new FormData();
    formData.append('file', file);  // The file parameter name should match your backend

    return fetchApi<any>(`/Student/Import?courseId=${courseId}`, {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json',

        }
    });
};

export const StudentExport = async (id: string): Promise<any> => {
    return  fetchApiBlob('/Student/Export', {
        body: JSON.stringify({ id }),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    });
}

export const StudentDownloadTemplate = async (): Promise<any> => {
    const url = `${API_BASE_URL}/Student/Template`;
    return  fetchApiBlob('/Student/Template', {
        method: 'POST',
    });
}